import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center py-12" }
const _hoisted_2 = { class: "w-full max-w-md mb-4" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "w-full bg-gray-200 rounded-full h-2 overflow-hidden" }
const _hoisted_5 = { class: "text-center mt-2" }
const _hoisted_6 = { class: "text-sm font-medium text-[#157813]" }
const _hoisted_7 = { class: "mt-4 text-center" }
const _hoisted_8 = { class: "text-lg font-medium text-gray-900" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-gray-600 mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-center"
}
const _hoisted_11 = { class: "text-xs text-gray-500 px-3 py-1 bg-gray-100 rounded-full" }

import { onMounted, onUnmounted, ref } from 'vue';

interface Props {
  title?: string;
  subtitle?: string;
  status?: string;
  duration?: number; // Duration in milliseconds for progress animation
  autoProgress?: boolean; // Whether to auto-animate progress
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingIndicator',
  props: {
    title: { default: 'Loading...' },
    subtitle: { default: '' },
    status: { default: '' },
    duration: { default: 3000 },
    autoProgress: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const progress = ref(0);
let progressInterval: number | undefined;

const startProgress = () => {
  if (!props.autoProgress) return;
  
  progress.value = 0;
  const incrementInterval = 50; // Update every 50ms
  const incrementAmount = (100 / props.duration) * incrementInterval;
  
  progressInterval = window.setInterval(() => {
    if (progress.value < 95) {
      // Slow down as we approach 95%
      const slowdownFactor = progress.value > 80 ? 0.3 : 1;
      progress.value += incrementAmount * slowdownFactor;
    }
  }, incrementInterval);
};

const setProgress = (value: number) => {
  progress.value = Math.max(0, Math.min(100, value));
};

const completeProgress = () => {
  progress.value = 100;
  if (progressInterval) {
    clearInterval(progressInterval);
  }
};

// Expose methods for parent components
__expose({
  setProgress,
  completeProgress
});

onMounted(() => {
  startProgress();
});

onUnmounted(() => {
  if (progressInterval) {
    clearInterval(progressInterval);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "h-full bg-gradient-to-r from-[#157813] to-[#46cc44] rounded-full transition-all duration-300 ease-out relative overflow-hidden",
            style: _normalizeStyle({ width: `${progress.value}%` })
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent shimmer" }, null, -1)
          ]))], 4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round(progress.value)) + "%", 1)
        ])
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "relative" }, [
      _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-2 border-[#157813] border-t-transparent" }),
      _createElementVNode("div", { class: "absolute inset-0 rounded-full h-8 w-8 border border-[#157813]/20" })
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.status), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})